// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebarWrapper__EjuVI {
  box-shadow: var(--default-box-shadow);
  min-height: 100vh;
}
.Sidebar_sidebarWrapper__EjuVI .Sidebar_sideBarContainer__kYpy1 {
  position: sticky;
  overflow-x: hidden;
  overflow-y: auto;
  top: 80px;
  height: calc(100vh - 80px);
}`, "",{"version":3,"sources":["webpack://./src/component/common/sidebar/Sidebar.module.scss"],"names":[],"mappings":"AAAA;EACI,qCAAA;EACA,iBAAA;AACJ;AACI;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;AACR","sourcesContent":[".sidebarWrapper{\n    box-shadow: var(--default-box-shadow);\n    min-height: 100vh;\n\n    .sideBarContainer {\n        position: sticky;\n        overflow-x: hidden;\n        overflow-y: auto;\n        top: 80px;\n        height: calc(100vh - 80px);\n       \n    }\n    // .active-menu-item {\n    //     background:linear-gradient(#EEE3E3 5%, #C5DDF0 45%, #B3CEE5 51%) !important;\n    //   }\n    //   .active-menu-item:hover {\n    //     background:linear-gradient(#EEE3E3 5%, #C5DDF0 45%, #B3CEE5 51%) !important;\n    //   }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarWrapper": `Sidebar_sidebarWrapper__EjuVI`,
	"sideBarContainer": `Sidebar_sideBarContainer__kYpy1`
};
export default ___CSS_LOADER_EXPORT___;
